import React from 'react';
import PropTypes from 'prop-types';

// import { Export, Review } from 'src/components/ProductsTable/components';
import { Review } from 'src/components/ProductsTable/components';
import { Visible, Spacer } from 'src/core/components';

const ActionsCellContainer = ({ row }) => {
  const { values: { actions } } = row;
  const { canExport, detailsLink } = actions;
  // const { productId, canExport, detailsLink } = actions;

  return (
    <>
      <Review detailsLink={detailsLink} />
      <Visible when={canExport}>
        <Spacer top={6} />
        {/* teporarily disable Export functionality */}
        {/* <Export productsIds={[productId]} /> */}
      </Visible>
    </>
  );
};

ActionsCellContainer.propTypes = {
  row: PropTypes.object.isRequired,
};

export default ActionsCellContainer;
